import { render, staticRenderFns } from "./shoppingCart.vue?vue&type=template&id=45b570ab&scoped=true"
import script from "./shoppingCart.vue?vue&type=script&lang=js"
export * from "./shoppingCart.vue?vue&type=script&lang=js"
import style0 from "./shoppingCart.vue?vue&type=style&index=0&id=45b570ab&prod&lang=scss&scoped=true"
import style1 from "./shoppingCart.vue?vue&type=style&index=1&id=45b570ab&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b570ab",
  null
  
)

export default component.exports